// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Button, Table } from "antd";
// import {
//   Avatar_06,
//   Avatar_07,
//   Avatar_14,
//   Avatar_18,
//   Avatar_19,
//   Avatar_22,
//   Avatar_26,
//   Avatar_29,
// } from "../../../Routes/ImagePath";
// import DeleteModal from "../../../components/modelpopup/DeleteModal";
// import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
// import SearchBox from "../../../components/SearchBox";
// import Breadcrumbs from "../../../components/Breadcrumbs";
// import ClientsFilter from "../../../components/ClientsFilter";
// import PropertyFilter from "./PropertyFilter";
// import { AddPropertyModel } from "./AddPropertyModel";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import PropertyVisitdeleteModal from "../../../components/modelpopup/PropertyVisitdeleteModal";
// import moment from "moment";

// const PropertyList = () => {
//   // const data = [
//   //   {
//   //     id: 1,
//   //     Name: "Carlson Tech",
//   //     ClientId: "CLT-0008",
//   //     ContactPerson: "Betty Carlson",
//   //     Email: "bettycarlson@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-danger",
//   //     Status: "Inactive",
//   //     Image: Avatar_22,
//   //   },
//   //   {
//   //     id: 2,
//   //     Name: "Cream Inc",
//   //     ClientId: "CLT-0003",
//   //     ContactPerson: "Ruby Bartlett",
//   //     Email: "rubybartlett@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_07,
//   //   },
//   //   {
//   //     id: 3,
//   //     Name: "Delta Infotech",
//   //     ClientId: "CLT-0002",
//   //     ContactPerson: "Tressa Wexler",
//   //     Email: "tressawexler@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-danger",
//   //     Status: "Inactive",
//   //     Image: Avatar_29,
//   //   },
//   //   {
//   //     id: 4,
//   //     Name: "Global Technologies",
//   //     ClientId: "CLT-0001",
//   //     ContactPerson: "Barry Cuda",
//   //     Email: "barrycuda@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_19,
//   //   },
//   //   {
//   //     id: 5,
//   //     Name: "International Software Inc",
//   //     ClientId: "CLT-0006",
//   //     ContactPerson: "Walter Weaver",
//   //     Email: "walterweaver@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_18,
//   //   },
//   //   {
//   //     id: 6,
//   //     Name: "Mercury Software Inc",
//   //     ClientId: "CLT-0007",
//   //     ContactPerson: "Amanda Warren",
//   //     Email: "amandawarren@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_26,
//   //   },
//   //   {
//   //     id: 7,
//   //     Name: "Mustang Technologies",
//   //     ClientId: "CLT-0005",
//   //     ContactPerson: "Daniel Deacon",
//   //     Email: "danieldeacon@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_14,
//   //   },
//   //   {
//   //     id: 8,
//   //     Name: "Wellware Company",
//   //     ClientId: "CLT-0004",
//   //     ContactPerson: "Misty Tison",
//   //     Email: "mistytison@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_06,
//   //   },
//   // ];

//   const [data,setData] = useState([])

//   const PropertyData = async() => {
//     try {
//       const userId = JSON.parse(sessionStorage.getItem('user'))?.id
//     const response =await axios.get(`${Api_Url}api/v1/PropertyVisit?UserId=${userId}&PageNumber=1&PageSize=100`,{
//       headers: {
//         Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user'))?.accessToken}`
//       }
//     })
//     console.log("done",response.data?.data)
//     setData(response?.data?.data)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(()=>{
//     PropertyData()
//   },[])

//   const [deleteId,setDeleteId] = useState(null)
//   const PropertyVisitDeleteFunc=async () => {
//     try {
//       const response = await axios.delete(`${Api_Url}api/v1/PropertyVisit/${deleteId}`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       PropertyData()
//     } catch (error) {
//       return error.message
//     }
//   }

//   const columns = [
//     {
//       title: "Name",
//       dataIndex: "name",
//       render: (text, record) => (
//         <span className="table-avatar">
//           <Link to="/profile" className="avatar">
//             <img alt="" src={record.selfieUrl} />
//           </Link>
//           <Link to="/profile">{text}</Link>
//         </span>
//       ),
//     },
//     {
//       title: "Branch Name",
//       dataIndex: "branchName",
//     },
//     {
//       title: "Application Number",
//       dataIndex: "applicationNo",
//     },
//     {
//       title: "Mobile",
//       dataIndex: "mobile",
//     },
//     {
//       title: "Property Type",
//       dataIndex: "propertyType",
//     },
//     {
//       title: "Property of End Use",
//       dataIndex: "propertyForEndUse",
//     },
//     {
//       title: "Property Address",
//       dataIndex: "propertyAddress",
//     },
//     {
//       title: "Tentative Market Value",
//       dataIndex: "tentativeMarketValue",
//     },
//     {
//       title: "Last Activity",
//       dataIndex: "",
//       render: (text, record) => (
//         <span className="table-avatar">
//           {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
//         </span>
//       ),
//     },
//     // {
//     //   title: "Email",
//     //   dataIndex: "Email",
//     //   sorter: (a, b) => a.Email.length - b.Email.length,
//     // },

//     // {
//     //   title: "Mobile",
//     //   dataIndex: "Mobile",
//     //   sorter: (a, b) => a.Mobile.length - b.Mobile.length,
//     // },
//     // {
//     //   title: "Status",
//     //   dataIndex: "Status",
//     //   render: (text) => (
//     //     <div className="dropdown">
//     //       <Link
//     //         to="#"
//     //         className="btn btn-white btn-sm btn-rounded dropdown-toggle"
//     //         data-bs-toggle="dropdown"
//     //         aria-expanded="false"
//     //       >
//     //         <i
//     //           className={
//     //             text === "Active"
//     //               ? "far fa-dot-circle text-success"
//     //               : "far fa-dot-circle text-danger"
//     //           }
//     //         />{" "}
//     //         {text}{" "}
//     //       </Link>
//     //       <div className="dropdown-menu">
//     //         <Link className="dropdown-item" to="#">
//     //           <i className="far fa-dot-circle text-success" /> Active
//     //         </Link>
//     //         <Link className="dropdown-item" to="#">
//     //           <i className="far fa-dot-circle text-danger" /> Inactive
//     //         </Link>
//     //       </div>
//     //     </div>
//     //   ),
//     //   sorter: (a, b) => a.Status.length - b.Status.length,
//     // },
//     {
//       title: "Location",
//       dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
//       render: (text, record) => (
//         <a
//           href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <i class="fa-solid fa-location-dot"></i>
//         </a>
//       )},
//     // {
//     //   title: "Action",
//     //   render: (item) => (
//     //     <div className="dropdown dropdown-action text-end">
//     //       <Link
//     //         to="#"
//     //         className="action-icon dropdown-toggle"
//     //         data-bs-toggle="dropdown"
//     //         aria-expanded="false"
//     //       >
//     //         <i className="material-icons">more_vert</i>
//     //       </Link>
//     //       <div className="dropdown-menu dropdown-menu-right">
//     //         <Link
//     //           className="dropdown-item"
//     //           to="#"
//     //           data-bs-toggle="modal"
//     //           data-bs-target="#edit_client"
//     //         >
//     //           <i className="fa fa-pencil m-r-5" /> Edit
//     //         </Link>
//     //         <Link
//     //           className="dropdown-item"
//     //           to="#"
//     //           data-bs-toggle="modal"
//     //           data-bs-target="#delete"
//     //           onClick={()=>setDeleteId(item.id)}
//     //         >
//     //           <i className="fa fa-trash m-r-5" /> Delete
//     //         </Link>
//     //       </div>
//     //     </div>
//     //   ),
//     //   sorter: true,
//     // },
//   ];

//   // const columns = [
//   //   {
//   //     title: "Name",
//   //     dataIndex: "userName",
//   //     render: (text, record) => (
//   //       <span className="table-avatar">
//   //         <Link to="/profile" className="avatar">
//   //           <img alt="" src={record.selfieUrl} />
//   //         </Link>
//   //         <Link to="/profile">{text}</Link>
//   //       </span>
//   //     ),
//   //   },
//   //   {
//   //     title: "Activity",
//   //     dataIndex: "name",
//   //   },
//   //   {
//   //     title: "Branch Name",
//   //     dataIndex: "branchName",
//   //   },
//   //   {
//   //     title: "Last Activity",
//   //     dataIndex: "",
//   //     render: (text, record) => (
//   //       <span className="table-avatar">
//   //         {moment(record.activityDate).format("MMMM Do YYYY, h:mm:ss a")}
//   //       </span>
//   //     ),
//   //   },
//   //   {
//   //     title: "View",
//   //     dataIndex: "actions",
//   //     render: (text, record) => (
//   //       <Button className="btn-property">
//   //           <i className="fa-solid fa-eye"></i>
//   //           </Button>
//   //     ),
//   //   },
//   //   // {
//   //   //   title: "Mobile",
//   //   //   dataIndex: "mobile",
//   //   // },

//   //   // {
//   //   //   title: "Property Address",
//   //   //   dataIndex: "propertyAddress",
//   //   // },
//   //   // {
//   //   //   title: "Property Type",
//   //   //   dataIndex: "propertyType",
//   //   // },
//   //   // {
//   //   //   title: "Property For End Use",
//   //   //   dataIndex: "propertyForEndUse",
//   //   // },
//   //   // {
//   //   //   title: "Email",
//   //   //   dataIndex: "Email",
//   //   //   sorter: (a, b) => a.Email.length - b.Email.length,
//   //   // },

//   //   // {
//   //   //   title: "Mobile",
//   //   //   dataIndex: "Mobile",
//   //   //   sorter: (a, b) => a.Mobile.length - b.Mobile.length,
//   //   // },
//   //   // {
//   //   //   title: "Status",
//   //   //   dataIndex: "Status",
//   //   //   render: (text) => (
//   //   //     <div className="dropdown">
//   //   //       <Link
//   //   //         to="#"
//   //   //         className="btn btn-white btn-sm btn-rounded dropdown-toggle"
//   //   //         data-bs-toggle="dropdown"
//   //   //         aria-expanded="false"
//   //   //       >
//   //   //         <i
//   //   //           className={
//   //   //             text === "Active"
//   //   //               ? "far fa-dot-circle text-success"
//   //   //               : "far fa-dot-circle text-danger"
//   //   //           }
//   //   //         />{" "}
//   //   //         {text}{" "}
//   //   //       </Link>
//   //   //       <div className="dropdown-menu">
//   //   //         <Link className="dropdown-item" to="#">
//   //   //           <i className="far fa-dot-circle text-success" /> Active
//   //   //         </Link>
//   //   //         <Link className="dropdown-item" to="#">
//   //   //           <i className="far fa-dot-circle text-danger" /> Inactive
//   //   //         </Link>
//   //   //       </div>
//   //   //     </div>
//   //   //   ),
//   //   //   sorter: (a, b) => a.Status.length - b.Status.length,
//   //   // },
//   //   {
//   //     title: "Location",
//   //     dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
//   //     render: (text, record) => (
//   //       <a
//   //         href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
//   //         target="_blank"
//   //         rel="noopener noreferrer"
//   //       >
//   //         <i class="fa-solid fa-location-dot"></i>
//   //       </a>
//   //     )},
//   //   // {
//   //   //   title: "Action",
//   //   //   render: (item) => (
//   //   //     <div className="dropdown dropdown-action text-end">
//   //   //       <Link
//   //   //         to="#"
//   //   //         className="action-icon dropdown-toggle"
//   //   //         data-bs-toggle="dropdown"
//   //   //         aria-expanded="false"
//   //   //       >
//   //   //         <i className="material-icons">more_vert</i>
//   //   //       </Link>
//   //   //       <div className="dropdown-menu dropdown-menu-right">
//   //   //         <Link
//   //   //           className="dropdown-item"
//   //   //           to="#"
//   //   //           data-bs-toggle="modal"
//   //   //           data-bs-target="#edit_client"
//   //   //         >
//   //   //           <i className="fa fa-pencil m-r-5" /> Edit
//   //   //         </Link>
//   //   //         <Link
//   //   //           className="dropdown-item"
//   //   //           to="#"
//   //   //           data-bs-toggle="modal"
//   //   //           data-bs-target="#delete"
//   //   //           onClick={()=>setDeleteId(item.id)}
//   //   //         >
//   //   //           <i className="fa fa-trash m-r-5" /> Delete
//   //   //         </Link>
//   //   //       </div>
//   //   //     </div>
//   //   //   ),
//   //   //   sorter: true,
//   //   // },
//   // ];
//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content container-fluid">
//           {/* Page Header */}
//           <div className="page-header">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <h3 className="page-title">Property Visit</h3>
//                 <ul className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link to="/dashboard">Dashboard</Link>
//                   </li>
//                   <li className="breadcrumb-item active">Property Visit</li>
//                 </ul>
//               </div>
//               <div className="col-md-8 float-end ms-auto">
//                 <div className="d-flex title-head">
//                   <div className="view-icons">
//                     <div className="form-sort">
//                       <Link to="#" className="list-view btn btn-link">
//                         <i className="las la-file-export" />
//                         Export
//                       </Link>
//                     </div>
//                   </div>
//                   <Breadcrumbs
//                   modal="#add_client"
//                   name="Add Property Visit"
//                   Linkname="/clients"
//                   Linkname1="/clients-list"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* <Breadcrumbs
//             maintitle="Property Visit"
//             title="Dashboard"
//             subtitle="property visit"
//             modal="#add_client"
//             name="Add Property Visit"
//             Linkname="/clients"
//             Linkname1="/clients-list"
//           /> */}
//           {/* /Page Header */}
//           <PropertyFilter />
//           <div className="row">
//             <div className="col-md-12">
//               <div className="table-responsive">
//                 <SearchBox />
//                 <Table
//                   className="table-striped"
//                   style={{ overflowX: "auto" }}
//                   columns={columns}
//                   dataSource={data}
//                   rowKey={(record) => record.id}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <AddPropertyModel loadPropertDataFunction={PropertyData} />
//       <PropertyVisitdeleteModal Name="Delete Client" propertyDeleteFunc={PropertyVisitDeleteFunc} />
//     </>
//   );
// };

// export default PropertyList;

// Modal

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table } from "antd";
import {
  Avatar_06,
  Avatar_07,
  Avatar_14,
  Avatar_18,
  Avatar_19,
  Avatar_22,
  Avatar_26,
  Avatar_29,
} from "../../../Routes/ImagePath";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
import SearchBox from "../../../components/SearchBox";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ClientsFilter from "../../../components/ClientsFilter";
import PropertyFilter from "./PropertyFilter";
import { AddPropertyModel } from "./AddPropertyModel";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import PropertyVisitdeleteModal from "../../../components/modelpopup/PropertyVisitdeleteModal";
import moment from "moment";

const PropertyList = () => {

  const [data, setData] = useState([]);

  const PropertyData = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/PropertyVisit?UserId=${userId}&PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      console.log("done", response.data?.data);
      setData(response?.data?.data);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    PropertyData();
  }, []);

  const [deleteId, setDeleteId] = useState(null);
  const PropertyVisitDeleteFunc = async () => {
    try {
      const response = await axios.delete(
        `${Api_Url}api/v1/PropertyVisit/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      PropertyData();
    } catch (error) {
      return error.message;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile" className="avatar">
            <img alt="" src={record.selfieUrl} />
          </Link>
          <Link to="/profile">{text}</Link>
        </span>
      ),
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Application Number",
      dataIndex: "applicationNo",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
    },
    {
      title: "Property Type",
      dataIndex: "propertyType",
    },
    {
      title: "Property of End Use",
      dataIndex: "propertyForEndUse",
    },
    {
      title: "Property Address",
      dataIndex: "propertyAddress",
    },
    {
      title: "Tentative Market Value",
      dataIndex: "tentativeMarketValue",
    },
    {
      title: "Last Activity",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
    {
      title: "Location",
      dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
      render: (text, record) => (
        <a
          href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-location-dot"></i>
        </a>
      ),
    },
  ]

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">Property Visit</h3>
              <div>
                <button className="btn border me-3">
                  <Link to="#" className="list-view btn btn-link">
                    <i className="las la-file-export" />
                    Export
                  </Link>
                </button>
                <button
                  className="btn btn-primary submit-btn mb-2"
                  onClick={handleOpenModal}
                >
                  Add Property Visit
                </button>
                {isModalOpen && (
                  <AddPropertyModel
                    onClose={handleCloseModal}
                    loadPropertDataFunction={PropertyData}
                  />
                )}
              </div>
            </div>
          </div>

          {/* <div className="page-header">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Property Visit</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Property Visit</li>
                </ul>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                    <div className="form-sort">
                      <Link to="#" className="list-view btn btn-link">
                        <i className="las la-file-export" />
                        Export
                      </Link>
                    </div>
                  </div>
                  <Breadcrumbs
                  modal="#add_client"
                  name="Add Property Visit"
                  Linkname="/clients"
                  Linkname1="/clients-list"
                  />
                </div>
              </div>
            </div>
          </div> */}

          {/* <Breadcrumbs
            maintitle="Property Visit"
            title="Dashboard"
            subtitle="property visit"
            modal="#add_client"
            name="Add Property Visit"
            Linkname="/clients"
            Linkname1="/clients-list"
          /> */}
          {/* /Page Header */}
          {/* <PropertyFilter /> */}
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <AddPropertyModel loadPropertDataFunction={PropertyData} /> */}
      <PropertyVisitdeleteModal
        Name="Delete Client"
        propertyDeleteFunc={PropertyVisitDeleteFunc}
      />
    </>
  );
};

export default PropertyList;
